import React from 'react'
import styled from 'styled-components'
import { InputGroup, InputGroupAddon, Input, Button } from 'reactstrap'
import { FaSearch } from 'react-icons/fa'

import { FONTS } from '../../constants'

export const SearchBar = ({ width, height, handleSearch }) => {
  return (
    <Root width={ width } height={ height }>
      <InputGroup>
        <SearchInput
          id='keywordSearch'
          placeholder='Search'
          onChange={ e => {
            if (e.target.value === '') handleSearch()
          } }
          onKeyDown={ e => {
            if (e.keyCode === 13) handleSearch()
          } }
        />
        <InputGroupAddon addonType='append' onClick={ handleSearch }>
          <SearchButton height={ height }>
            <FaSearch />
          </SearchButton>
        </InputGroupAddon>
      </InputGroup>
    </Root>
  )
}

const Root = styled.div`
    width: ${p => p.width || '300px'};
    height: ${p => p.height || '26px'};

    .input-group-append:focus, :active {
        outline: none;
        box-shadow: none;
    }

    .input-group, .input-group-append, input {
      height: 100%;
    }
`

const SearchInput = styled(Input)`
    background: #F9F9F9;
    border: 1px solid #EAEAEA;
    border-radius: 4px;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.NORMAL_SIZE};
    color: #9BA3AB;

    :focus {
        box-shadow: none;
        border: 1px solid #EAEAEA;
    }
`

const SearchButton = styled(Button)`
    width: 30px;
    height: ${p => p.height || '26px'};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    background: #F9F9F9;
    border: 1px solid #EAEAEA;
    color: #9BA3AB;
    padding: 0;

    :focus {
        outline: none;
        box-shadow: none;
    }
`



// WEBPACK FOOTER //
// ./src/components/search-bar/index.js